/** Browser notifications round two (2026-10-18; brief rule 2): the installed app's icon badge, the pure part. A positive count sets the badge
 *  to that number, 0 clears it (`clearAppBadge`, or `setAppBadge(0)` where only that exists), a count not known yet changes nothing, a
 *  browser without the Badging API is left alone, and a refusal (a site that is not installed, a revoked permission) is swallowed. */
export type BadgeNavigator = { setAppBadge?: (n?: number) => Promise<void>; clearAppBadge?: () => Promise<void> };

export async function showAppBadge(count: number | null | undefined, nav: BadgeNavigator = globalThis.navigator as unknown as BadgeNavigator): Promise<void> {
  if (count === null || count === undefined || !nav) return;
  try {
    if (count > 0) await nav.setAppBadge?.(count);
    else if (nav.clearAppBadge) await nav.clearAppBadge();
    else await nav.setAppBadge?.(0);
  } catch { /* refused: the icon simply shows nothing */ }
}
